var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPerp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m19.485 11.208c2.6483-2.5942 6.885-2.5942 9.5333 0l6.2696 6.1417c2.7267 2.671 2.7267 7.0609 0 9.7319l-10.926 10.704 7.8362 7.6763c1.493 1.4625 1.5177 3.8584 0.0552 5.3514-1.4626 1.493-3.8585 1.5177-5.3515 0.0552l-18.984-18.597c-2.7266-2.671-2.7266-7.0608 0-9.7318l11.568-11.332zm-0.5313 21.28 10.486-10.272-5.1881-5.0822-10.486 10.272 5.1881 5.0822z",
    clipRule: "evenodd",
    fill: "#3CEAAA",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.379 16.397c2.6483-2.5942 6.885-2.5942 9.5333 0l6.2696 6.1417c2.7267 2.671 2.7267 7.0609 0 9.7319l-18.984 18.597c-1.493 1.4625-3.8889 1.4378-5.3514-0.0552-1.4626-1.493-1.4379-3.8889 0.0551-5.3514l7.8363-7.6763-5.6286-5.5137c-2.7266-2.671-2.7266-7.0609 0-9.7319l6.2697-6.1417zm4.7666 16.09 5.1881-5.0823-5.1881-5.0822-5.1881 5.0822 5.1881 5.0823z",
    clipRule: "evenodd",
    fill: "#03BCE4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.955 27.418-5.5112-5.2347-5.2861 5.1915 5.3804 5.3527 5.4169-5.3095z",
    fill: "#00A4E1",
    opacity: 0.95
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "#fff"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerp);
export default __webpack_public_path__ + "static/media/perp.4ea43cab50920009346a509a3e36c426.svg";
export { ForwardRef as ReactComponent };